import { render, staticRenderFns } from "./StartupCardPopup.vue?vue&type=template&id=33f73115&scoped=true&"
import script from "./StartupCardPopup.vue?vue&type=script&lang=js&"
export * from "./StartupCardPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f73115",
  null
  
)

export default component.exports